/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteEditorCtrl', 
        ["$scope", "$filter", "dialog", "dialogsModel", "$dialog", "CompanyImageSrv", "AppAttribute",
            "AppData", "App", "AppSrv", "WidgetView", "$timeout", "CategoryView", "CureCategoryView", "ProductCategoryView", "LoyaltyCardCategoryView", "LanguageManager",
        function ($scope, $filter, dialog, dialogsModel, $dialog, CompanyImageSrv, AppAttribute,
            AppData, App, AppSrv, WidgetView, $timeout, CategoryView, CureCategoryView, ProductCategoryView, LoyaltyCardCategoryView, LanguageManager) {
            $scope.ad = dialogsModel.ad;
            $scope.parentScope = dialogsModel.parentScope;
            const token = $scope.ad.tokenAdmin
            $scope.dd = {
                view: {
                    editType: dialogsModel.editType,
                    visible: true,
                    displayError: false,
                    tab: 0,
                    subTab: $scope.ad.view.dialogWebSiteEditorCtrl.subTab,
                    tabOffer: 0,
                    edited: {
                        categoryView: dialogsModel.categoryView,
                        serviceView: dialogsModel.serviceView,
                        productView: dialogsModel.productView,
                        cureView: dialogsModel.cureView,
                        loyaltyCardView: dialogsModel.loyaltyCardView,
                        widgetView: dialogsModel.widgetView
                    },
                    imageUploadRunning: false,
                    serviceCategoryRootView: $scope.ad.view.categoryRootView,//for selector
                    cServiceCategoryView: $scope.ad.view.categoryRootView,
                    cProductCategoryView: $scope.ad.view.productCategoryRootView,
                    cCureCategoryView: $scope.ad.view.cureCategoryRootView,
                    cLoyaltyCardCategoryView: $scope.ad.view.loyaltyCardCategoryRootView,
                    previousHomeItemsView: $scope.ad.view.homeItemsView.slice(0),
                    hsHr: $scope.ad.view.humanResourcesView.length != 0,
                    hsPr: $scope.ad.view.physicalResourcesView.length != 0
                },
                flowConfig: {
                    target: '/rest/companyImageUpload',
                    method: 'octet',
                    query: null,
                    maxChunkRetries: 1,
                    chunkRetryInterval: 5000,
                    simultaneousUploads: 1,
                    chunkSize: 1024 * 1024 * 5,
                    singleFile: true,
                    testChunks: false,
                    headers: {Authorization: token}
                },
                timeoutReload: null
            };

            if (dialogsModel.categoryView) {
                if (dialogsModel.categoryView instanceof CategoryView)
                    $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'service' };
                if (dialogsModel.categoryView instanceof CureCategoryView)
                    $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'cure' };
                if (dialogsModel.categoryView instanceof ProductCategoryView)
                    $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'product' };
                if (dialogsModel.categoryView instanceof LoyaltyCardCategoryView)
                    $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'loyaltyCard' };
            }
            if (dialogsModel.serviceView) {
                $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'service' };
                dialogsModel.serviceView.initSkills($scope.ad.view.humanResourcesView, $scope.ad.view.physicalResourcesView);
                if (!dialogsModel.serviceView.getModel())
                    $scope.dd.view.tab = 1;
            }
            if (dialogsModel.productView) {
                $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'product' };
                if (!dialogsModel.productView.getModel())
                    $scope.dd.view.tab = 1;
            }

            if (dialogsModel.cureView) {
                $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'cure' };
                if (!dialogsModel.cureView.getModel())
                    $scope.dd.view.tab = 1;
            }
            if (dialogsModel.loyaltyCardView) {
                $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'loyaltyCard' };
                if (!dialogsModel.loyaltyCardView.getModel())
                    $scope.dd.view.tab = 1;
            }

            if (dialogsModel.widgetView) {
                $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'widget' };
                dialogsModel.widgetView.displaySelectorLarge = dialogsModel.widgetView.widgetsView.length == 0;
                if ($scope.dd.view.edited.widgetView.type == 'default-offer' || $scope.dd.view.edited.widgetView.type == 'fullscreen-offer' || $scope.dd.view.edited.widgetView.widgetsView.length > 0)
                    $scope.dd.view.tabOffer = 1;
            }

            console.log($scope.dd.view);
            $scope.close = function () {
                dialog.close(true);
            }

            $scope.saveEditedCategory = function () {
                if ($scope.dd.view.edited.categoryView)
                    $scope.dd.view.edited.categoryView.updateModel();
                $scope.dd.view.edited.categoryView = null;
                $scope.displayChangeMsg = false;
                dialog.close(true);
            };
            $scope.cancelEditedCategory = function () {
                $scope.dd.view.edited.categoryView.reloadModel();
                $scope.dd.view.displayError = false;
                $scope.dd.view.edited.categoryView = null;
                $scope.displayChangeMsg = false;
                dialog.close(false);
            };
            $scope.saveEditedService = function () {
                if ($scope.dd.view.edited.serviceView) {
                    $scope.dd.view.edited.serviceView.updateModel();
                    $scope.dd.view.displayError = false;
                    $scope.dd.view.edited.serviceView = null;
                    dialog.close(true);
                }
            };
            $scope.cancelEditedService = function () {
                $scope.dd.view.edited.serviceView.reloadModel();
                $scope.dd.view.displayError = false;
                $scope.dd.view.edited.serviceView = null;
                dialog.close(false);
            };
            $scope.duplicateService = function (serviceView) {
                if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.isChanged())
                    $scope.dd.view.edited.serviceView.updateModel();

                $scope.dd.view.edited.serviceView = serviceView.getClone();
                if ($scope.dd.view.edited.serviceView.label && $scope.dd.view.edited.serviceView.label != '')
                    $scope.dd.view.edited.serviceView.label = "Copie de " + $scope.dd.view.edited.serviceView.label;
                if (serviceView.parentCategoryView) {
                    serviceView.parentCategoryView.addServiceView($scope.dd.view.edited.serviceView);
                    if (serviceView.parentCategoryView.image && serviceView.parentCategoryView.image !== null)
                        $scope.dd.view.edited.serviceView.setImage(serviceView.parentCategoryView.image, true);
                }

            };

            $scope.saveEditedProduct = function () {
                if ($scope.dd.view.edited.productView) {
                    $scope.dd.view.edited.productView.updateModel(true);//don't save quantity
                    $scope.dd.view.displayError = false;
                    $scope.dd.view.edited.productView = null;
                    $scope.displayChangeMsg = false;
                    $scope.dd.view.filterProductsView = null;
                    $scope.dd.view.filter = "";
                    dialog.close(true);
                }
            };
            $scope.cancelEditedProduct = function () {
                if ($scope.dd.view.edited.productView) {
                    $scope.dd.view.edited.productView.reloadModel();
                    $scope.dd.view.displayError = false;
                    $scope.dd.view.edited.productView = null;
                    $scope.dd.view.filterProductsView = null;
                    $scope.dd.view.filter = "";
                    $scope.displayChangeMsg = false;
                    dialog.close(false);
                }
            };
            $scope.saveEditedCure = function () {
                if ($scope.dd.view.edited.cureView) {
                    $scope.dd.view.edited.cureView.updateModel();
                    $scope.dd.view.displayError = false;
                    $scope.dd.view.edited.cureView = null;
                    $scope.displayChangeMsg = false;
                    dialog.close(true);
                }
            };
            $scope.cancelEditedCure = function () {
                $scope.dd.view.edited.cureView.reloadModel();
                $scope.dd.view.displayError = false;

                $scope.dd.view.edited.cureView = null;
                $scope.displayChangeMsg = false;
                dialog.close(false);
            };
            $scope.saveEditedLoyaltyCard = function () {
                if ($scope.dd.view.edited.loyaltyCardView) {
                    $scope.dd.view.edited.loyaltyCardView.updateModel();
                    $scope.dd.view.displayError = false;

                    $scope.dd.view.edited.loyaltyCardView = null;
                    $scope.displayChangeMsg = false;
                    dialog.close(true);
                }
            }

            $scope.cancelEditedLoyaltyCard = function () {
                $scope.dd.view.edited.loyaltyCardView.reloadModel();
                $scope.dd.view.displayError = false;
                $scope.dd.view.edited.loyaltyCardView = null;
                $scope.displayChangeMsg = false;
                dialog.close(false);
            }

            $scope.saveEditedGiftItem = function () {
                saveEditedGiftItemByType($scope.ad.view.giftItemTypeSelected, $scope.ad.view.currentGiftItemImage);
                $scope.ad.view.giftItemTypeSelected = "";
                dialog.close(false);
            }

            function saveEditedGiftItemByType(giftItemTypeSelected, image) {
                switch (giftItemTypeSelected) {
                    case "delivery":
                        $scope.ad.view.domainView.saveGiftItemDeliveryImage(image);
                        break;
                    case "printable":
                        $scope.ad.view.domainView.saveGiftItemPrintableImage(image);
                        break;
                    case "mail":
                        $scope.ad.view.domainView.saveGiftItemMailImage(image);
                        break;
                    default:
                        break;
                }
            }

            $scope.cancelEditedGiftItem = function () {
                dialog.close(false);
            }

            $scope.onStartUploadImage = function (message) {
                $scope.dd.view.imageUploadRunning = true;
            }

            $scope.initGiftItemFlowConfig = function() {
                $scope.dd.flowConfig.query = { 
                    companyCode: $scope.ad.companyCode, 
                    type: 'giftItem' 
                };
                return $scope.dd.flowConfig;
            }

            $scope.onUploadImageSuccess = function (message) {
                $scope.dd.view.imageUploadRunning = false;
                let companyImage = null;
                try {
                    companyImage = JSON.parse(message);
                    $scope.ad.view.imagesCompanyView.unshift(companyImage);
                    if (companyImage && companyImage.type === "giftItem") {
                        $scope.updateCurrentGiftItemImage(companyImage);
                    } else {
                        if ($scope.dd.view.edited.serviceView) {
                            $scope.dd.view.edited.serviceView.setCompanyImage(companyImage);
                        }
                        if ($scope.dd.view.edited.categoryView) {
                            $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
                        }
                        if ($scope.dd.view.edited.productView) {
                            $scope.dd.view.edited.productView.setCompanyImage(companyImage);
                        }
                        if ($scope.dd.view.edited.cureView) {
                            $scope.dd.view.edited.cureView.setCompanyImage(companyImage);
                        }
                        if ($scope.dd.view.edited.loyaltyCardView) {
                            $scope.dd.view.edited.loyaltyCardView.setCompanyImage(companyImage);
                        }
                        if ($scope.dd.view.edited.widgetView) {
                            $scope.dd.view.edited.widgetView.setImage(companyImage, !$scope.dd.view.edited.widgetView.pWidgetView);
                        }
                    }
                } catch (error) {
                    console.error("WebSiteEditorCtrl.onUploadImageSuccess: %s, JSON: {%s} ", error.message, message);
                }
            }

            $scope.imageIsSelected = function (image) {
                if ($scope.dd.view.edited.serviceView) {
                    if (!$scope.dd.view.edited.serviceView.companyImage && $scope.dd.view.edited.serviceView.image === image)
                        return true
                }
                else
                    if ($scope.dd.view.edited.productView) {
                        if (!$scope.dd.view.edited.productView.companyImage && $scope.dd.view.edited.productView.image === image)
                            return true
                    }
                    else
                        if ($scope.dd.view.edited.cureView) {
                            if (!$scope.dd.view.edited.cureView.companyImage && $scope.dd.view.edited.cureView.image === image)
                                return true
                        }
                        else
                            if ($scope.dd.view.edited.loyaltyCardView) {
                                if (!$scope.dd.view.edited.loyaltyCardView.companyImage && $scope.dd.view.edited.loyaltyCardView.image === image)
                                    return true
                            }
                            else
                                if ($scope.dd.view.edited.categoryView && !$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image === image)
                                    return true;
                                else
                                    if ($scope.dd.view.edited.widgetView && $scope.dd.view.edited.widgetView.img == image)
                                        return true;

                return false;
            };

            $scope.companyImageIsSelected = function (companyImage) {
                if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.companyImage === companyImage)
                    return true;

                if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.companyImage === companyImage)
                    return true;
                
                if ($scope.dd.view.edited.cureView && $scope.dd.view.edited.cureView.companyImage === companyImage)
                    return true;

                if ($scope.dd.view.edited.loyaltyCardView && $scope.dd.view.edited.loyaltyCardView.companyImage === companyImage)
                    return true;

                if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage === companyImage)
                    return true;
        
                if ($scope.dd.view.edited.widgetView && $scope.dd.view.edited.widgetView.img == companyImage)
                    return true;
                    
                return false;
            }

            $scope.setImage = function (image) {
                if ($scope.dd.view.edited.serviceView) {
                    if (image === $scope.dd.view.edited.serviceView.image) {
                        if ($scope.dd.view.edited.serviceView.image != null) {
                            $scope.dd.view.edited.serviceView.setImage(null);
                        }
                        else {
                            $scope.dd.view.edited.serviceView.setImage($scope.dd.view.edited.serviceView.parentCategoryView.image);
                        }
                    }
                    else if (image != null) {
                        $scope.dd.view.edited.serviceView.setImage(image);
                    }
                    else {
                        $scope.dd.view.edited.serviceView.setImage($scope.dd.view.edited.serviceView.parentCategoryView.image);
                    }
                }
                if ($scope.dd.view.edited.productView) {
                    if (image === $scope.dd.view.edited.productView.image) {
                        if ($scope.dd.view.edited.productView.image != null) {
                            $scope.dd.view.edited.productView.setImage(null);
                        }
                        else {
                            $scope.dd.view.edited.productView.setImage($scope.dd.view.edited.productView.parentCategoryView.image);
                        }
                    }
                    else if (image != null) {
                        $scope.dd.view.edited.productView.setImage(image);
                    }
                    else {
                        $scope.dd.view.edited.productView.setImage($scope.dd.view.edited.productView.parentCategoryView.image);
                    }
                }
                if ($scope.dd.view.edited.cureView) {
                    if (image === $scope.dd.view.edited.cureView.image) {
                        if ($scope.dd.view.edited.cureView.image != null) {
                            $scope.dd.view.edited.cureView.setImage(null);
                        }
                        else {
                            $scope.dd.view.edited.cureView.setImage($scope.dd.view.edited.cureView.parentCategoryView.image);
                        }
                    }
                    else if (image != null) {
                        $scope.dd.view.edited.cureView.setImage(image);
                    }
                    else {
                        $scope.dd.view.edited.cureView.setImage($scope.dd.view.edited.cureView.parentCategoryView.image);
                    }
                }
                if ($scope.dd.view.edited.loyaltyCardView) {
                    if (image === $scope.dd.view.edited.loyaltyCardView.image) {
                        if ($scope.dd.view.edited.loyaltyCardView.image != null) {
                            $scope.dd.view.edited.loyaltyCardView.setImage(null);
                        }
                        else {
                            $scope.dd.view.edited.loyaltyCardView.setImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.image);
                        }
                    }
                    else if (image != null) {
                        $scope.dd.view.edited.loyaltyCardView.setImage(image);
                    }
                    else {
                        $scope.dd.view.edited.loyaltyCardView.setImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.image);
                    }
                }
                if ($scope.dd.view.edited.categoryView) {
                    if (image === $scope.dd.view.edited.categoryView.image) {
                        if ($scope.dd.view.edited.categoryView.image != null) {
                            $scope.dd.view.edited.categoryView.setImage(null);
                        }
                        else {
                            $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                        }
                    }
                    else if (image != null) {
                        $scope.dd.view.edited.categoryView.setImage(image);
                    }
                    else {
                        $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                    }
                }
                if ($scope.dd.view.edited.widgetView) {
                    if (image) {
                        $scope.dd.view.edited.widgetView.setImage(image, !$scope.dd.view.edited.widgetView.pWidgetView);
                    }
                }
            };
            $scope.setCompanyImage = function (companyImage) {
                if ($scope.dd.view.edited.serviceView) {
                    if (companyImage === $scope.dd.view.edited.serviceView.companyImage) {
                        if ($scope.dd.view.edited.serviceView.companyImage != null) {
                            $scope.dd.view.edited.serviceView.setCompanyImage(null);
                        }
                        else {
                            $scope.dd.view.edited.serviceView.setCompanyImage($scope.dd.view.edited.serviceView.parentCategoryView.companyImage);
                        }
                    }
                    else if (companyImage != null) {
                        $scope.dd.view.edited.serviceView.setCompanyImage(companyImage);
                    }
                    else {
                        $scope.dd.view.edited.serviceView.setCompanyImage($scope.dd.view.edited.serviceView.parentCategoryView.companyImage);
                    }
                }
                if ($scope.dd.view.edited.productView) {
                    if (companyImage === $scope.dd.view.edited.productView.companyImage) {
                        if ($scope.dd.view.edited.productView.companyImage != null) {
                            $scope.dd.view.edited.productView.setCompanyImage(null);
                        }
                        else {
                            $scope.dd.view.edited.productView.setCompanyImage($scope.dd.view.edited.productView.parentCategoryView.companyImage);
                        }
                    }
                    else if (companyImage != null) {
                        $scope.dd.view.edited.productView.setCompanyImage(companyImage);
                    }
                    else {
                        $scope.dd.view.edited.productView.setCompanyImage($scope.dd.view.edited.productView.parentCategoryView.companyImage);
                    }
                }
                if ($scope.dd.view.edited.cureView) {
                    if (companyImage === $scope.dd.view.edited.cureView.companyImage) {
                        if ($scope.dd.view.edited.cureView.companyImage != null) {
                            $scope.dd.view.edited.cureView.setCompanyImage(null);
                        }
                        else {
                            $scope.dd.view.edited.cureView.setCompanyImage($scope.dd.view.edited.cureView.parentCategoryView.companyImage);
                        }
                    }
                    else if (companyImage != null) {
                        $scope.dd.view.edited.cureView.setCompanyImage(companyImage);
                    }
                    else {
                        $scope.dd.view.edited.cureView.setCompanyImage($scope.dd.view.edited.cureView.parentCategoryView.companyImage);
                    }
                }
                if ($scope.dd.view.edited.loyaltyCardView) {
                    if (companyImage === $scope.dd.view.edited.loyaltyCardView.companyImage) {
                        if ($scope.dd.view.edited.loyaltyCardView.companyImage != null) {
                            $scope.dd.view.edited.loyaltyCardView.setCompanyImage(null);
                        }
                        else {
                            $scope.dd.view.edited.loyaltyCardView.setCompanyImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.companyImage);
                        }
                    }
                    else if (companyImage != null) {
                        $scope.dd.view.edited.loyaltyCardView.setCompanyImage(companyImage);
                    }
                    else {
                        $scope.dd.view.edited.loyaltyCardView.setCompanyImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.companyImage);
                    }
                }
                if ($scope.dd.view.edited.categoryView) {
                    if (companyImage === $scope.dd.view.edited.categoryView.companyImage) {
                        if ($scope.dd.view.edited.categoryView.companyImage != null) {
                            $scope.dd.view.edited.categoryView.setCompanyImage(null);
                        }
                        else {
                            $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                        }
                    }
                    else if (companyImage != null) {
                        $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
                    }
                    else {
                        $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                    }
                }
                if ($scope.dd.view.edited.widgetView) {
                    if (companyImage) {
                        $scope.dd.view.edited.widgetView.setImage(companyImage, !$scope.dd.view.edited.widgetView.pWidgetView);
                    }
                }
            }

            $scope.updateCurrentGiftItemImage = function (image) {
                image.isSelected = !image.isSelected;
                if ($scope.ad.view.currentGiftItemImage !== image) {
                    if ($scope.ad.view.currentGiftItemImage) {
                        $scope.ad.view.currentGiftItemImage.isSelected = false;
                    }
                    $scope.ad.view.currentGiftItemImage = image;
                }
                if (!image.isSelected) {
                    $scope.ad.view.currentGiftItemImage = null;
                }
            }

            $scope.openDeletedServiceViewConfirmDialog = function () {
                if ($scope.dd.view.edited.serviceView) {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/removeConfirm.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"] = $scope.dd.view.edited.serviceView.label;
                                return tableModel;
                            }
                        }
                    };
                    $scope.dd.view.visible = false;
                    var d = $dialog.dialog(opts);
                    d.open().then(function (result) {
                        if (result) {
                            $scope.removeEditedService();
                            dialog.close(true);
                        }
                        else
                            $scope.dd.view.visible = true;
                    });
                }
            }

            $scope.openDeletedCategoryViewConfirmDialog = function () {
                if ($scope.dd.view.edited.categoryView) {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/removeConfirm.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                                return tableModel;
                            }
                        }
                    };
                    $scope.dd.view.visible = false;
                    var d = $dialog.dialog(opts);
                    d.open().then(function (result) {
                        if (result) {
                            $scope.removeEditedCategory();
                            dialog.close(true);
                        }
                        else
                            $scope.dd.view.visible = true;
                    });
                }
            };

            $scope.removeEditedService = function () {
                if ($scope.dd.view.edited.serviceView) {
                    $scope.dd.view.edited.serviceView.removeModel();
                    var parentCategoryView = $scope.dd.view.edited.serviceView.parentCategoryView;
                    if (parentCategoryView)
                        parentCategoryView.removeServiceView($scope.dd.view.edited.serviceView);

                    $scope.dd.view.edited.serviceView = null;
                    $scope.displayChangeMsg = false;
                }
            }

            $scope.removeEditedCategory = function () {
                if ($scope.dd.view.edited.categoryView) {
                    $scope.dd.view.edited.categoryView.removeModel();
                    var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
                    if (parentCategoryView)
                        parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
                    $scope.dd.view.edited.categoryView = null;
                    $scope.displayChangeMsg = false;
                }
            }

            $scope.removeImageServiceCompanyView = function (companyImage) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            tableModel["label"] = companyImage.label;
                            return tableModel;
                        }
                    }
                };
                $scope.dd.view.visible = false;
                var d = $dialog.dialog(opts);
                d.open().then( (result) => {
                    if (result) {
                        var index = $scope.ad.view.imagesCompanyView.indexOf(companyImage);
                        if (index != -1) {
                            $scope.ad.view.imagesCompanyView.splice(index, 1);
                            CompanyImageSrv.remove(companyImage);
                            saveEditedGiftItemByType($scope.ad.view.giftItemTypeSelected, null);
                        }
                    }
                    $scope.dd.view.visible = true;
                });
            }

            $scope.changeHomeServicePositionView = function (itemView, indexTarget) {
                //Change the category position
                // This : parentCategory
                // serviceView : service to move to indexTarget

                var index = $scope.ad.view.homeItemsView.indexOf(itemView);
                if (indexTarget != -1 && index != -1 && indexTarget <= $scope.ad.view.homeItemsView.length) {
                    $scope.ad.view.homeItemsView.splice(index, 1); //remove it
                    if (indexTarget == $scope.ad.view.homeItemsView.length)
                        $scope.ad.view.homeItemsView.push(itemView);
                    else
                        $scope.ad.view.homeItemsView.splice(indexTarget, 0, itemView);//insert
                    $scope.updateHomeOrder();
                }
            }

            $scope.updateHomeOrder = function () {
                for (var i = 0; i < $scope.ad.view.homeItemsView.length; i++)
                    $scope.ad.view.homeItemsView[i].item.homeOrder = i;
            }

            $scope.toggleHomeItem = function (itemView, type) {
                var index = $scope.getHomeItemIndex(itemView);
                if (index == -1) {
                    $scope.ad.view.homeItemsView.push({ type: type, item: itemView, active: false });
                    itemView.isOnHome = true;
                }
                else {
                    $scope.ad.view.homeItemsView.splice(index, 1);//remove
                    itemView.isOnHome = false;
                }
                $scope.updateHomeOrder();
            }

            $scope.getHomeItemIndex = function (item) {
                for (var i = 0; i < $scope.ad.view.homeItemsView.length; i++)
                    if ($scope.ad.view.homeItemsView[i].item == item)
                        return i;
                return -1;
            }
            
            $scope.cancelHomeItems = function () {
                $scope.ad.view.homeItemsView = $scope.dd.view.previousHomeItemsView;
                for (var i = 0; i < $scope.ad.view.homeItemsView.length; i++)
                    $scope.ad.view.homeItemsView[i].item.reloadModel();
                dialog.close(false);
            }

            $scope.saveHomeItems = function () {
                var saveArray = [];
                var item;
                for (var i = 0; i < $scope.dd.view.previousHomeItemsView.length; i++) {
                    item = $scope.dd.view.previousHomeItemsView[i].item.getModel();
                    if (item && $scope.dd.view.previousHomeItemsView[i].item.isOnHome != item.isOnHome)
                        saveArray.push($scope.dd.view.previousHomeItemsView[i].item)
                }

                for (var i = 0; i < $scope.ad.view.homeItemsView.length; i++) {
                    item = $scope.ad.view.homeItemsView[i].item.getModel();
                    if (item && ($scope.ad.view.homeItemsView[i].item.isOnHome != item.isOnHome || $scope.ad.view.homeItemsView[i].item.homeOrder != item.homeOrder)
                        && saveArray.indexOf($scope.ad.view.homeItemsView[i].item) == -1)
                        saveArray.push($scope.ad.view.homeItemsView[i].item);

                }
                for (var i = 0; i < saveArray.length; i++)
                    saveArray[i].updateModel();
                $scope.ad.view.homeItemsView = $filter('orderBy')($scope.ad.view.homeItemsView.slice(0), 'item.homeOrder'); //force reload
                dialog.close(true);
            };

            $scope.updateGrid = function () {
                if (!$scope.dd.timeoutReload) {
                    var array = $scope.ad.view.homeItemsView;
                    $scope.ad.view.homeItemsView = null;
                    $scope.dd.timeoutReload = $timeout(function () {
                        $scope.ad.view.homeItemsView = array;
                        $scope.dd.timeoutReload = null;
                    }, 2000);
                }
            }
            $scope.editSubWidgetView = function (widgetView, editType) {
                if (widgetView.type == 'video')
                    return;
                if (widgetView.type == 'object' && editType == 'object') {
                    console.log($scope.parentScope);
                    switch (widgetView.objectType) {
                        case "category":
                        case "cureCategory":
                        case "productCategory":
                        case "loyaltyCardCategory":
                            $scope.parentScope.editCategoryView(widgetView.object);
                            break;
                        case "service":
                            $scope.parentScope.editServiceView(widgetView.object);
                            break;
                        case "product":
                            $scope.parentScope.editProductView(widgetView.object);
                            break;
                        case "cure":
                            $scope.parentScope.editCureView(widgetView.object);
                            break;
                        case "gift":
                            break;
                    }
                    return;
                }

                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials-web/editor/subWidgetEditor.html',
                    controller: 'WebSiteEditorCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            tableModel["widgetView"] = widgetView;
                            tableModel["ad"] = $scope.ad;
                            tableModel["editType"] = editType;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {

                    }
                });
                //$scope.adjustModalPosition();
                $timeout(function () {
                    var elm = $(".modal");
                    if (elm && elm[0]) {
                        var height = $(window).height();
                        var scrollTop = $(window).scrollTop();
                        elm.animate({ top: scrollTop + 50, height: height - 100 });

                    }
                    else
                        $timeout(function () {
                            var elm = $(".modal");
                            if (elm && elm[0]) {
                                var height = $(window).height();
                                var scrollTop = $(window).scrollTop();
                                elm.animate({ top: scrollTop + 50, height: height - 100 });

                            }
                        }, 1000
                        );
                }, 500
                );
            }

            $scope.saveDefaultWidget = function (widgetView) {
                if (widgetView) {
                    for (var i = 0; i < $scope.ad.view.homeGridWidgetsView.length; i++)
                        $scope.ad.view.homeGridWidgetsView[i].updateFromDefault(widgetView);
                    var webSiteApp = AppData.getAppByCode("webSite");
                    if (!webSiteApp) {
                        webSiteApp = new App();
                        webSiteApp.setCode("webSite");
                    }
                    var appAttr = webSiteApp.getAppAttribute("defaultWidget");
                    if (!appAttr) {
                        appAttr = new AppAttribute("defaultWidget", null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    }
                    appAttr.text = JSON.stringify(widgetView.getObjectResource());

                    AppSrv.save(webSiteApp);
                    dialog.close(true);

                }
            }

            $scope.saveWidgets = function (widgetView) {
                if (widgetView && widgetView.object)//save object
                {
                    widgetView.object.updateModel();
                }
                dialog.close(true);
            }

            $scope.removeWidget = function (widgetView) {
                var index = $scope.ad.view.homeGridWidgetsView.indexOf(widgetView)
                if (index != -1)
                    $scope.ad.view.homeGridWidgetsView.splice(index, 1);
                $scope.saveWidgets();
            };
            $scope.cancelWidgetView = function (widgetView) {
                if (widgetView)
                    if (widgetView.type == "fullscreen-offer" || widgetView.type == "default-offer") {
                        $scope.parentScope.loadHomeWidgetView(null, true);
                    }
                    else {
                        var webSiteApp = AppData.getAppByCode("webSite");
                        if (webSiteApp) {

                            var appAttr = webSiteApp.getAppAttribute("homeGridWidgets");
                            if (appAttr && appAttr.text && appAttr.text != '') {
                                let homeGridWidgets = null;
                                try {
                                    homeGridWidgets = JSON.parse(appAttr.text);
                                } catch (e) {
                                    console.log('cancelWidgetView SON.parse error', e);
                                }

                                if (homeGridWidgets) {
                                    if (widgetView.index != -1 && widgetView.index < homeGridWidgets.length)
                                        $scope.ad.view.homeGridWidgetsView[widgetView.index].loadDataFrom(homeGridWidgets[widgetView.index], true);
                                }
                            }
                        }
                    }
                dialog.close(false);
            }

            if (dialogsModel.serviceView)
                dialogsModel.serviceView.initSkills($scope.ad.view.humanResourcesView, $scope.ad.view.physicalResourcesView);

        }
    ]);



// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteEditorCtrl.js